export { default } from './reducers';
export { default as types } from './types';
export { default as selectors } from './selectors';
export { default as operations } from './operations';



// WEBPACK FOOTER //
// ./src/state/ducks/segmentCreation/index.js